<template>
  <div>
    <el-dialog
      title="确认退款"
      :visible.sync="showRefund"
      width="30%"
      :before-close="closefn"
      center
    >
      <div class="dialog-connect">确认发起退款，发起退款后不可变更</div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="closefn">取 消</el-button>
        <el-button type="primary" @click="editsubfn">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
export default {
  props: {
    showRefund: {
      type: Boolean,
      default: false,
    },
    orderId: {
      type: String,
      default: "",
    },
  },
  data() {
    return {};
  },
  methods: {
    closefn() {
      this.$emit("closefn");
    },
    editsubfn() {
      // this.$emit("editsubfn", this.orderId);
      this.$emit("closefn");
      this.$post(`/vip/refund?id=${this.orderId}`).then((res) => {
        if (res.data.code === 1000) {
          this.$message.success("退款成功");
          this.$emit("editsubfn", this.orderId);
        } else {
          this.$message.error(res.data.msg);
        }
      });
    },
  },
};
</script>

<style scoped>
.dialog-connect {
  margin: 0;
  font-size: 14px;
  color: #666;
  display: flex;
  justify-content: center;
}
</style>
